import { ComponentPropsWithoutRef } from 'react';
import './HeaderH1.css';
import GAME_PAGES from '../../constants/GAME_PAGES';
import { useStore } from '@hmpu/powerups.store';

export type HeaderH1Props = {
  textValue: string;
  animate: boolean;
  ariaHidden: boolean;
  [key: string]: unknown;
} & ComponentPropsWithoutRef<"h1">;

const defaultProps = {
  animate: true,
  ariaHidden: true,
}

const HeaderH1 = ({ textValue, ariaHidden, animate, ...rest }: HeaderH1Props) => {
  const page = useStore((state) => state.currentPage);
  const locale = useStore((state) => state.locale) || "en-US";

  return (
    <>
      <div className={`HeaderH1-wrapper ${page === GAME_PAGES.DISCLAIMER ? "disclaimerHeader" : ""}`}>
      {/* <div className={`spark-element ${page === GAME_PAGES.DISCLAIMER ? "disclaimer-sparks" : ""}`}></div> */}
        <div className="headerH1-wrap">
          <div aria-hidden={true} className={`HeaderH1`} data-text={textValue} {...rest}>{textValue}</div>
          <h1 aria-hidden={false} className={`HeaderH1-a11y`}>{textValue}</h1>
        </div>
      </div>
    </>
  )
}

HeaderH1.defaultProps = defaultProps;

export default HeaderH1;